<div class="popup-container tlms-popup">
  <header>
    <div class="header" style="display:block">Add Fiscal Year</div>
    <button class="close" style="top:-3px" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <ng-container>
    <div style="padding: 16px 24px 16px 24px;">
      <div class="col-12" style="width: 100%;">
        <div class="form-group custom-body-content">
          <label class="label required">New Fiscal Year</label>
          <div>
            <input type="hidden" min="1900" max="9999" id="fiscalYear" name="fiscalYear" required class="fiscalyear"
              [(ngModel)]="fiscalYear">
            <input type="text" maxlength="4" id="fiscalYearText" name="fiscalYearText" required class="fiscalyear"
              [(ngModel)]="fiscalYear">
          </div>
        </div>
        <label *ngIf="enableError" class="errormsg"> Please fill in the required fields! </label>
      </div>
    </div>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
      <button (click)="onNoClick()" class="mCancel"> CANCEL
      </button>
      <button class="costpl-submit" style="display: inline" (click)="saveClick()">
        SAVE
      </button>
    </div>
  </ng-container>
</div>